import type { Emitter } from 'mitt'
import mitt from 'mitt'

export enum EventNames {
  RICH_TEXT_EDITOR_USE_AI_WIDGET = 'richTextEditor:useAIWidget',
}

type EventBusEvents = {
  [EventNames.RICH_TEXT_EDITOR_USE_AI_WIDGET]: void
}

const emitter: Emitter<EventBusEvents> = mitt<EventBusEvents>()

export const useEventBus = () => {
  return {
    emit: (event: EventNames, payload?: any) => emitter.emit(event, payload),
    on: (event: EventNames, callback: (payload?: any) => void) =>
      emitter.on(event, callback),
    off: (event: EventNames, callback: (payload?: any) => void) =>
      emitter.off(event, callback),
  }
}
